import RGBA from '../Fonts/RGBA';
import game from '../Game/GameInstance';
import HoverMaskContainer from './HoverMaskContainer'

class HoverMaskItem {

  constructor(name, x, y, width, height) {

    this.name = name;

    this.events = {
      over : null,
      out : null,
      click : null,
      move : null
    };

    this.x = x;
    this.y = y;
    this.id = Math.random();
    this.width = width;
    this.height = height;
    this.enabled = true;
    this.repeated = false;

    this.disableCursor = false;

  }

  update(keys)
  {
    for (let i in keys) {
      if (keys.hasOwnProperty(i)) {
        this[i] = keys[i];
      }
    }
    return this;
  }

  noCursor()
  {
    this.disableCursor = true;
    return this;
  }


  over(callback) {
    this.events.over = callback;
    return this;
  }

  move(callback) {
    this.events.move = callback;
    return this;
  }

  out(callback) {
    this.events.out = callback;
    return this;
  }

  click(callback) {
    this.events.click = callback;
    return this;
  }

  disable() {
    return this.setEnabled(false);
  }

  enable() {
    return this.setEnabled(true);
  }

  repeat(status) {
    if (typeof status === 'undefined') {
      status = true;
    }
    this.repeated = status;
    return this;
  }

  setEnabled(status) {
    this.enabled = !!status;
    return this;
  }

  callOver() {
    if (this.events.over) {
      this.events.over(...arguments);
    }
  }

  callOut() {
    if (this.events.out) {
      this.events.out(...arguments);
    }
  }

  callClick() {
    if (this.events.click) {
      this.events.click(...arguments);
    }
  }

}


let hovering = null;
let clicking = null;

export default class HoverMask
{

  constructor(owner, isStatic) {

    this.items = [];
    this.register = {};
    this.owner = owner;
    this.isStatic = !!isStatic;

    HoverMaskContainer.instance().push(this);

  }

  mouseMove(x, y) {
    x = x - this.owner.x + (this.isStatic ? 0 : (game.x / game.scale));
    y = y - this.owner.y + (this.isStatic ? 0 : (game.y / game.scale));

    let i = this.items.length;
    while (i--) {
      let item = this.items[i];

      if (!item.enabled) {
        continue;
      }

      if (x > item.x && x < item.x + item.width) {

        if (y > item.y && y < item.y + item.height) {

          return item;

        }

      }

    }

  }

  click(x, y) {

    x = x - this.owner.x + (this.isStatic ? 0 : (game.x / game.scale));
    y = y - this.owner.y + (this.isStatic ? 0 : (game.y / game.scale));

    let i = this.items.length;
    while (i--) {

      let item = this.items[i];

      if (!item.enabled) {
        continue;
      }

      if (x > item.x && x < item.x + item.width) {

        if (y > item.y && y < item.y + item.height) {

          item.callClick(x, y);
          return true;

        }

      }

    }

  }

  add(name, x, y, width, height)
  {

    let item = this.findInRegister(name);

    if (item === null) {
      item = new HoverMaskItem(name, x, y, width, height);
      this.items.push(item);
      this.register[name] = item;
      return item;
    }

    return item.update({x,y,width,height});


  }

  remove(nameRegExp) {

    let i = this.items.length;
    while (i--) {
      let item = this.items[i];
      if (item.name.match(nameRegExp)) {
        delete this.register[item.name];
        this.items.splice(i, 1);
      }
    }

    return this;

  }

  findInRegister(name) {
    if (this.register.hasOwnProperty(name)) {
      return this.register[name];
    }
    return null;
  }

  scale(n) {
    return Math.floor(n * this.owner.zoom);
  }

  debug(ctx) {

    ctx.beginPath();

    ctx.fillStyle = new RGBA(255,255,255,.5);

    this.items.forEach((item) => {


      if (item !== hovering && item !== clicking) {

        ctx.rect(this.scale(item.x) - game.x + this.scale(this.owner.x), this.scale(item.y) - game.y + this.scale(this.owner.y), this.scale(item.width), this.scale(item.height));
        ctx.font = '18px arial';

        ctx.fillText('⬅ ' + item.name, this.scale(item.x) - game.x + this.scale(this.owner.x + item.width) + 5, this.scale(item.y) - game.y + this.scale(this.owner.y - 5)+ 25);

      }


    });

    ctx.fillStyle = new RGBA(0,255,0,.2);

    ctx.fill();

    if (hovering) {

      this.items.forEach((item) => {
        if (item === hovering) {
          ctx.beginPath();
          ctx.fillStyle = new RGBA(0, 255, 0, .8);
          ctx.rect(this.scale(item.x) - game.x + this.scale(this.owner.x), this.scale(item.y) - game.y + this.scale(this.owner.y), this.scale(item.width), this.scale(item.height));
          ctx.fill();
        }
      });

    }



  }


}
